$(function(){
  var compareCount = localStorage.getItem('sf__compare-products');
  /*$(compareCount).change(function() {
    alert( "Handler for .change() called." );
  });*/
  console.table(compareCount);
  window.addEventListener('storage', () => {
    // When local storage changes, dump the list to
    // the console.
    console.log(JSON.parse(window.localStorage.getItem('sf__compare-products')));
  });
  setTimeout(() => {
    if($('a[aria-label="deny cookies"]').text() == "Hanyatlás"){
      $('a[aria-label="deny cookies"]').text('Mégsem');
    }
  }, 500)
});